<template>
  <div class="search-content">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'AbilityLayout',
    data () {
      return {
        tabs: {
          items: [
            {
              key: '1',
              title: '报名管理'
            },
            {
              key: '2',
              title: '人员管理'
            },
            {
              key: '4',
              title: '场次管理'
            },
            {
              key: '5',
              title: '年份管理'
            }
          ],
          active: () => {
            switch (this.$route.path) {
              case '/ability/ApplyList':
                return '1'
              case '/ability/ApplyMemberList':
                return '2'
              case '/ability/SaiquList':
                return '4'
              case '/ability/SaijiList':
                return '5'
              default:
                return '1'
            }
          },
          callback: (key) => {
            switch (key) {
              case '1':
                this.$router.push('/ability/ApplyList')
                break
              case '2':
                this.$router.push('/ability/ApplyMemberList')
                break
              case '3':
                this.$router.push('/skill/ApplyMemberList')
                break
              case '4':
                this.$router.push('/ability/SaiquList')
                break
              case '5':
                this.$router.push('/ability/SaijiList')
                break

              default:
                this.$router.push('/workplace')
            }
          }
        },
        search: false
      }
    },
    computed: {

    },
    methods: {
    }
  }
</script>

<style lang="less" scoped>
  .search-head{
    background-color: #fff;
    margin: -25px -24px -24px;
    .search-input{
      text-align: center;
      margin-bottom: 16px;
    }
  }
  .search-content{
    margin-top: 0px;
  }
</style>
